import SockJS from 'sockjs-client';
import Stomp from 'stomp-websocket';
import helper from '../util/helpers';

let baseUrl = process.env.VUE_APP_BASE_URL;
let isSeller = process.env.VUE_APP_TARGET === 'sellergate';

if (process.env.NODE_ENV === 'alpha') {
  baseUrl = location.protocol.indexOf('https:') > -1 ? process.env.VUE_APP_HTTPS_BASE_URL : process.env.VUE_APP_HTTP_BASE_URL;
}

const getDefaultState = () => {
  return {
    stompClient: null,
    isConnecting: false,
    isConnected: false,
    connectTrigger: 1,
    subscriptions: []
  };
};

const state = getDefaultState();

const START_CONNECT = () => {
  state.isConnecting = true;
};

const END_CONNECT = () => {
  state.isConnecting = false;
  state.isConnected = true;
  state.stompClient.connected = true;
  return true;
};

const FAIL_CONNECT = () => {
  state.isConnecting = false;
  state.isConnected = false;
  state.stompClient.connected = false;
};

// 웹소켓 연결
const connect = () => {
  return new Promise((resolve) => {
    START_CONNECT();

    if (isSeller) {
      state.stompClient = Stomp.over(new SockJS(baseUrl + '/api/webSocket'));
    } else {
      state.stompClient = Stomp.over(new SockJS(baseUrl + '/api/webSocket', null, { transports: ['websocket', 'xhr-polling'] }));
    }
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null;
    }
    if (state.stompClient) {
      state.stompClient.connect(
        {},
        () => {
          START_CONNECT();
          window.$mitt.emit('socket-connection-success');
          resolve();
          return true;
        },
        (error) => {
          console.log('소켓 연결 끊김', error);
          forceCloseConnection();
          FAIL_CONNECT();
          window.$mitt.emit('reconnect-start');
        }
      );
    }
  });
};

// 구독
const subscribe = (payload) => {
  let subscription = helper.findByKey(state.subscriptions, payload.key);
  if (subscription === undefined) {
    subscription = state.stompClient.subscribe(payload.subscribeUrl, (tick) => payload.callback(JSON.parse(tick.body), payload.chatRoom));
    const newSubscription = {
      key: payload.key,
      chatRoomId: payload.chatRoomId,
      subscriptionUrl: payload.subscribeUrl,
      id: subscription.id,
      subscription: subscription
    };
    state.subscriptions.push(newSubscription);
  }
  return subscription.id;
};

// 어바웃펫 입력 감지 커스텀 (웹소켓 전송)
const keyboardTypingSend = (payload) => {
  state.stompClient.send(
    `/api/publish/brand/${payload.brandId}`,
    {},
    JSON.stringify({ changeType: 'KEYBOARD_TYPING_SENSOR', data: { chatRoomId: payload.chatRoomId, typing: payload.typing } })
  );
};

// 구독 close
const closeSubscriptionWithPrefix = (prefix) => {
  let filtered = state.subscriptions.filter((e) => e.key.includes(prefix));

  state.subscriptions = state.subscriptions.filter((e) => !e.key.includes(prefix));
  filtered.forEach((releasable) => {
    releasable.subscription.unsubscribe();
  });
};

// 모든 소켓 종료
const forceCloseConnection = () => {
  if (state.subscriptions.length > 0) {
    console.log('모든 소켓 종료');
    state.subscriptions.forEach((releasable) => {
      releasable.subscription.unsubscribe();
    });
    state.subscriptions = [];
  }
};

export default {
  START_CONNECT,
  END_CONNECT,
  FAIL_CONNECT,
  subscribe,
  keyboardTypingSend,
  connect,
  closeSubscriptionWithPrefix,
  forceCloseConnection
};
